import { supabase } from '@/core/database/supabase';
import { permissionEngine } from '@/core/permissions/permissionEngine';
import type { UserLaborRate, LaborRateCreatePayload, LaborRateUpdatePayload } from '../types/laborRates.types';

export const laborRatesService = {
  async fetchRates(companyId: string) {
    if (!companyId) return [];

    const { data, error } = await supabase
      .from('user_labor_rates')
      .select(`
        *,
        user:users!user_id(full_name, email)
      `)
      .eq('company_id', companyId)
      .order('updated_at', { ascending: false });

    if (error) throw error;
    return (data || []) as unknown as UserLaborRate[];
  },

  async createRate(userId: string, payload: LaborRateCreatePayload) {
    await permissionEngine.assert(userId, 'inventory.rates.create', { companyId: payload.company_id });

    const { data, error } = await supabase
      .from('user_labor_rates')
      .insert({
        ...payload,
      })
      .select('id')
      .single();

    if (error) throw error;
    return data.id;
  },

  async updateRate(userId: string, companyId: string, id: string, payload: LaborRateUpdatePayload) {
    await permissionEngine.assert(userId, 'inventory.rates.update', { companyId });

    const { error } = await supabase
      .from('user_labor_rates')
      .update({
        ...payload,
        updated_at: new Date().toISOString(),
      })
      .eq('id', id)
      .eq('company_id', companyId);

    if (error) throw error;
    return true;
  },

  async deleteRate(userId: string, companyId: string, id: string) {
    await permissionEngine.assert(userId, 'inventory.rates.delete', { companyId });

    const { error } = await supabase
      .from('user_labor_rates')
      .delete()
      .eq('id', id)
      .eq('company_id', companyId);

    if (error) throw error;
    return true;
  },
};
